// 用户相关
import { handleBuryingEvent } from '@/hooks'

let user = null
if (localStorage.getItem('user')) {
  user = JSON.parse(localStorage.getItem('user'))
}

const state = {
  user: user
}

const mutations = {
  setUser(state, payload) {
    const { user } = payload
    state.user = user
    handleBuryingEvent('config', {
      user_unique_id: user?.id,
      big_activity_login_status: '登录'
    })
    localStorage.setItem('user', JSON.stringify(user))
  }
}

const getters = {
  getUser: (state) => {
    return state.user
  }
}

export default {
  state,
  mutations,
  getters
}